import {observer} from "mobx-react";
import * as React from "react";
import {createRef} from "react";
import {StepData} from "components/chart/StepData";
import {
  VictoryAxis,
  VictoryBar,
  VictoryChart,
  VictoryGroup,
  VictoryLegend,
  VictoryTheme,
  VictoryZoomContainer
} from "victory";
import StepBarChart from "components/chart/StepBarChart";

const colors = ["#e9724d", "#d6d727", "#92cad1", "#79ccb3", "#868686"];

@observer
export class BarChart extends React.Component<{ steps: any, feedItems: any }> {
  containerRef;

  constructor(props: { steps: any, feedItems: any }) {
    super(props);
    this.containerRef = createRef();
  }

  /**
   * In order to create a responsive fullscreen experience for the
   * graph, need to target the container and the contained SVG when
   * the graph mounts and modify the height/width to be empty so that
   * the orientation CSS can control these, and modify the container
   * to be perfectly centered.
   */
  componentDidMount() {
    if (this.containerRef.current && this.containerRef.current.children && this.containerRef.current.children.length > 0) {
      this.containerRef.current.children[0].style.height = '';
      this.containerRef.current.children[0].style.width = '';
      this.containerRef.current.children[0].style.userSelect = 'none';
      this.containerRef.current.children[0].style.touchAction = 'none';
      this.containerRef.current.children[0].style.position = 'fixed';
      this.containerRef.current.children[0].style.top = '50%';
      this.containerRef.current.children[0].style.left = '50%';
      this.containerRef.current.children[0].style.transform = 'translate(-50%, -50%)';
      this.containerRef.current.children[0].style.pointerEvents = 'none';
      if (this.containerRef.current.children[0].children && this.containerRef.current.children[0].children.length > 0) {
        this.containerRef.current.children[0].children[0].style.height = '';
        this.containerRef.current.children[0].children[0].style.width = '';
      }
    }
  }


  render() {

    // get chart data
    const barDataArray: StepData[] = [];
    let legendData: Array<any> = [];
    for (let s = 0; s < this.props.steps.length && s < colors.length; s++) {
      // extract the answers associated with each step
      barDataArray.push(new StepData(this.props.steps[s], this.props.feedItems));
      // add an entry for the legend that represents the step
      legendData.push({
        name: this.props.steps[s].shortName ? this.props.steps[s].shortName : "",
        symbol: {fill: colors[s]}
      });
    }

    // console.log("barDataArray", JSON.stringify(barDataArray, null, 2));

    // Tick Values
    let tickValues: Array<any> = [];
    for (let i = 0; i < barDataArray[0].answers.length; i++) {
      tickValues.push(barDataArray[0].answers[i].date.format('M/D'));
    }

    // for datasets larger than 5 items, set the zoom to the last five

    let zoomDomain = {};

    if (barDataArray[0].answers.length > 5) {
      let zoomEnd = barDataArray[0].answers.length - 1;
      let zoomStart = zoomEnd - 5;
      zoomDomain = {x: [zoomStart, zoomEnd]};
    }

    let desc = "Not enough data collected yet for a trend assessment.";
    if(barDataArray.length>0 && barDataArray[0].trends.overall.trend !== "insufficient-data") {
      desc = "";
      for(let i=0;i<barDataArray.length;i++) {
        desc = desc+" "+barDataArray[i].trendDescription;
      }
    }

    return (
      <div>
        <p className="chart-description">{desc}</p>
        <table className={'visuallyhidden'}>
          <thead>
          <tr>
            <th role={"col"}>Date</th>
            {barDataArray.map((barData, idx) => <th key={idx} role={"col"}>{barData.step.shortName}</th>)}
          </tr>
          </thead>
          <tbody>
          {barDataArray[0].answers.map((answer, answerIdx) => {
            return <tr>
              <td role={'row'}>{answer.date.format('M/D')}</td>
              {barDataArray.map((barData, bdidx) => {
                if(barData.answers.length>answerIdx) {
                  return <td key={bdidx}>{barData.answers[answerIdx].answer}</td>
                } else {
                  return <td key={bdidx}></td>
                }
              })}
            </tr>
          })}
          </tbody>
        </table>

        <StepBarChart barDataArray={barDataArray} />


    </div>
    );
  }
}
/*
 <div className="BarChartContainer" ref={this.containerRef} aria-hidden>
          <VictoryChart
            theme={VictoryTheme.material}
            domainPadding={40}
            padding={{left: 75, top: 50, right: 100, bottom: 75}}
            scale={{x: "linear", y: "linear"}}
            containerComponent={<VictoryZoomContainer allowPan={true} allowZoom={false} zoomDomain={zoomDomain}/>}
          >
            <VictoryLegend x={260} y={50}
                           orientation="vertical"
                           gutter={5}
                           style={{border: {stroke: "white"}, title: {fontSize: 8}}}
                           data={legendData}
            />
            <VictoryAxis label="Day" style={{
              axisLabel: {padding: 30}
            }}
                         tickValues={tickValues}
            />
            <VictoryAxis dependentAxis label="Score" style={{
              axisLabel: {padding: 40}
            }}
            />
            <VictoryGroup horizontal={false}
                          offset={10}
                          style={{data: {width: 6}}}
                          colorScale={colors}
            >

              {barDataArray.map((barData, idx) => {
                //
                let data = barData.xyData();
                for (let i = 0; i < data.length; i++) {
                  data[i].x = data[i].x.format('M/D');
                }
                return <VictoryBar key={`bar-${idx}`} data={data}/>;
              })}

            </VictoryGroup>
          </VictoryChart>

        </div>
 */